// services/UtilityServices.js
import { fetchWithAuth } from './api';

export const getSchemaDates = async (station) => {
  let url = `/api/reports/names?type=dag&station=${encodeURIComponent(station)}&isStandardUser=true`;

  const response = await fetchWithAuth(url);
  if (!response.ok) {
    throw new Error('Kunde inte hämta schemadatum');
  }

  const data = await response.json();

  return data
    .filter(name => name !== 'Underlag saknas')
    .sort();
};

export const getTodaysDate = () => {
  return new Date().toLocaleDateString('sv-SE', { timeZone: 'Europe/Stockholm' });
};


export const getActiveUserNames = async () => {
  const response = await fetchWithAuth('/api/admin/users/active');
  if (!response.ok) return [];

  const users = await response.json();
  return users.map(u => {
    if (u.connectionCount > 1)
      return `${u.userName} (${u.connectionCount})`;
    return u.userName;
  });
};